import { useState, useCallback } from 'react';

export const useToggle = (initial?: boolean): [boolean, () => void] => {
  const [value, setValue] = useState(Boolean(initial));
  const toggleValue = () => setValue(prevValue => !prevValue);
  return [value, toggleValue];
};

// Alternativ setState för bool som har separate settter för true och false istället för en parameter
export const useBoolState = (
  initial?: boolean
): [boolean, () => void, () => void] => {
  const [value, setValue] = useState(Boolean(initial));
  const setTrueValue = useCallback(() => setValue(true), [setValue]);
  const setFalseValue = useCallback(() => setValue(false), [setValue]);
  return [value, setTrueValue, setFalseValue];
};
